module.exports = __webpack_public_path__ + "static/media/poppins-v15-latin-600.4b6d7026.svg";